// Shopify Footer Language Translator
// This script detects the selected language and translates the footer to Finnish when needed

document.addEventListener('DOMContentLoaded', () => {
  // Initialize the translator
  const footerTranslator = new FooterTranslator();
  footerTranslator.init();
});

class FooterTranslator {
  constructor() {
    // Finnish translations for common footer elements
    this.translations = {
      // Navigation sections
      'Shop': 'Kauppa',
      'About': 'Tietoa meistä',
      'Collections': 'Kokoelmat',
      'Products': 'Tuotteet',
      'Contact Us': 'Yhteystiedot',
      'Help': 'Autamme',
      'FAQ': 'UKK',
      'Shipping': 'Toimitus',
      'Returns': 'Palautukset',
      'Terms of Service': 'Käyttöehdot',
      'Privacy Policy': 'Tietosuojakäytäntö',
      'Sustainability': 'Vastuullisuus',
      'Ingredients': 'Raaka-aineet',
      'Press': 'Medialle',
      'Product development services': 'Tuotekehityspalvelut',
      'Customer Stories': 'Asiakastarinoita',

      // Common footer elements
      'Subscribe': 'Tilaa',
      'Subscribe to our newsletter': 'Tilaa uutiskirjeemme',
      'Email address': 'Sähköpostiosoite',
      'Sign up': 'Rekisteröidy',
      'Follow us on': 'Seuraa meitä',
      'All rights reserved': 'Kaikki oikeudet pidätetään',
      'Customer Service': 'Asiakaspalvelu',
      'Payment Methods': 'Maksutavat',
      'My Account': 'Oma tili',
      'Copyright': 'Tekijänoikeus',
      'Powered by Shopify': 'Shopifyn avulla',
      'Payment methods': 'Maksutavat',
      'Delivery methods': 'Toimitustavat',
    };
    
    // Selectors for footer elements to translate
    this.footerSelectors = [
      'footer h2, footer h3, footer h4',  // Footer headings
      'footer a',                         // Footer links
      'footer p',                         // Footer paragraphs
      'footer label',                     // Footer form labels
      'footer button',                    // Footer buttons
      'footer input[type="submit"]',      // Footer submit buttons
      'footer .footer-menu li',           // Footer menu items
      'footer .footer-column li',         // Footer column items
    ];
    
    // Store original text content for reverting back from Finnish
    this.originalContent = new Map();
  }
  
  init() {
    // Listen for language selector changes
    this.setupLanguageChangeListeners();
    
    // Check initial language setting
    this.checkCurrentLanguage();
  }
  
  setupLanguageChangeListeners() {
    // Method 1: Listen for changes to language selector dropdown if present
    const languageSelectors = document.querySelectorAll('.language-selector, #LocaleSelector, [name="locale"]');
    languageSelectors.forEach(selector => {
      selector.addEventListener('change', () => this.handleLanguageChange());
    });
    
    // Method 2: Listen for clicks on language selection links
    document.addEventListener('click', (event) => {
      const languageLink = event.target.closest('a[data-locale], .locale-item a, .language-link');
      if (languageLink) {
        // Give the page a moment to update the locale before checking
        setTimeout(() => this.handleLanguageChange(), 100);
      }
    });
    
    // Method 3: Monitor URL changes which might indicate language changes
    let lastUrl = location.href; 
    new MutationObserver(() => {
      const url = location.href;
      if (url !== lastUrl) {
        lastUrl = url;
        this.checkCurrentLanguage();
      }
    }).observe(document, {subtree: true, childList: true});
  }
  
  checkCurrentLanguage() {
    // Various methods to detect current language
    const isFinish = this.isFinishLanguageSelected();
    
    if (isFinish) {
      this.translateFooterToFinnish();
    } else {
      this.revertToOriginalLanguage();
    }
  }
  
  isFinishLanguageSelected() {
    // Method 1: Check HTML lang attribute
    const htmlLang = document.documentElement.lang;
    if (htmlLang && htmlLang.toLowerCase().startsWith('fi')) {
      return true;
    }
    
    // Method 2: Check URL for language indicator
    const url = window.location.href.toLowerCase();
    if (url.includes('/fi/') || url.includes('?locale=fi') || url.includes('&locale=fi')) {
      return true;
    }
    
    // Method 3: Check selected option in language selector
    const languageSelector = document.querySelector('.language-selector, #LocaleSelector, [name="locale"]');
    if (languageSelector && languageSelector.value && languageSelector.value.toLowerCase().includes('fi')) {
      return true;
    }
    
    // Method 4: Look for any onpage indication of Finnish being selected
    const activeLanguageElement = document.querySelector('.language-selector .active, .language-selector .selected, .language-link.current');
    if (activeLanguageElement && activeLanguageElement.textContent.includes('Suomi')) {
      return true;
    }
    
    return false;
  }
  
  handleLanguageChange() {
    // Short timeout to ensure page has updated with new language setting
    setTimeout(() => this.checkCurrentLanguage(), 200);
  }
  
  translateFooterToFinnish() {
    const footerElements = this.getAllFooterElements();
    
    footerElements.forEach(element => {
      // Store original text if we haven't seen this element before
      if (!this.originalContent.has(element)) {
        this.originalContent.set(element, element.textContent.trim());
      }
      
      const originalText = this.originalContent.get(element);
      
      // Only translate if we have a translation for this text
      if (this.translations[originalText]) {
        element.textContent = this.translations[originalText];
      } else {
        // Try to translate partial matches or composed texts
        let translatedText = originalText;
        Object.keys(this.translations).forEach(key => {
          // Replace all occurrences of the key with its translation
          const regex = new RegExp(`\\b${key}\\b`, 'g');
          translatedText = translatedText.replace(regex, this.translations[key]);
        });
        
        // Only update if something was actually translated
        if (translatedText !== originalText) {
          element.textContent = translatedText;
        }
      }
    });
  }
  
  revertToOriginalLanguage() {
    // Revert all elements to their original text
    this.originalContent.forEach((originalText, element) => {
      if (element.textContent !== originalText) {
        element.textContent = originalText;
      }
    });
  }
  
  getAllFooterElements() {
    let elements = [];
    
    // Find the footer element(s)
    const footers = document.querySelectorAll('footer, .footer, #shopify-section-footer');
    
    if (footers.length === 0) {
      console.warn('No footer element found on the page');
      return elements;
    }
    
    // Get all elements matching our selectors within the footer
    footers.forEach(footer => {
      this.footerSelectors.forEach(selector => {
        const selectedElements = footer.querySelectorAll(selector);
        selectedElements.forEach(element => {
          // Only include elements with text content
          if (element.textContent && element.textContent.trim()) {
            elements.push(element);
          }
        });
      });
    });
    
    return elements;
  }
}